import { createAsyncThunk } from "@reduxjs/toolkit";
import instance, {
  AsyncThunkConfig,
  ApiResponse,
  isAxiosError,
  ApiError,
} from "../../../api/axiosConfig";
import { DocumentationItem } from "../../../api/documentationApi";
import { Examination } from "../../../api/examinationApi";
import { examinationURL } from "../../../utils/paths";
import { dispatchNotification } from "../../../utils/redux";
import { I18n } from "react-redux-i18n";

export const fetchExaminationDocumentation = createAsyncThunk<
  DocumentationItem[],
  string,
  AsyncThunkConfig
>("examination/documentation/get", async (examinationId, thunkAPI) => {
  try {
    const response = await instance.get<ApiResponse<DocumentationItem[]>>(
      `${examinationURL}${examinationId}/documents/`
    );

    return response.data.results;
  } catch (err) {
    if (isAxiosError(err) && err.response != null) {
      const extractedError = err.response.data as ApiError;

      dispatchNotification("error", extractedError.message);

      return thunkAPI.rejectWithValue(extractedError);
    }

    dispatchNotification("error");
    throw err;
  }
});

export const fetchExaminationDetails = createAsyncThunk<
  Examination,
  string,
  AsyncThunkConfig
>("examination/get", async (examinationId: string, thunkAPI) => {
  // Sprawdź czy parametry są prawidłowe
  if (!examinationId || examinationId === "undefined") {
    return thunkAPI.rejectWithValue({
      message: "Nieprawidłowe parametry",
      results: null,
      error: true,
    } as ApiError);
  }

  try {
    const response = await instance.get<ApiResponse<Examination>>(
      `${examinationURL}${examinationId}/`
    );

    return response.data.results;
  } catch (err) {
    if (isAxiosError(err) && err.response != null) {
      const extractedError = err.response.data as ApiError;

      dispatchNotification("error", extractedError.message);

      return thunkAPI.rejectWithValue(extractedError);
    }

    dispatchNotification("error");
    throw err;
  }
});

export const unblockedExmianiations = createAsyncThunk<
  { message: string; updated_count: number },
  number,
  AsyncThunkConfig
>("examination/unblocked", async (labId, thunkAPI) => {
  try {
    const response = await instance.post<
      ApiResponse<{ message: string; updated_count: number }>
      // eslint-disable-next-line camelcase
    >(`${examinationURL}unblock-examinations/`, { lab_id: labId });

    dispatchNotification("success", I18n.t("Snackbars.unblockedExamSuccess"));

    return response.data.results;
  } catch (err) {
    if (isAxiosError(err) && err.response != null) {
      const extractedError = err.response.data as ApiError;

      dispatchNotification("error", extractedError.message, true);

      return thunkAPI.rejectWithValue(extractedError);
    }

    dispatchNotification("error");
    throw err;
  }
});